// extracted by mini-css-extract-plugin
export default {"label":"azwURJssGjAVmCuMzjj6P","icon":"_210HZOLZLDoMNtTxnxpAOE","labelText":"_3Iyu3FSgXBCdlXP5YkvSU6"};